import { PARCEL_SERVICE_URL } from '../../map/constants'
import { RESULT_TYPES } from '../constants'


const processResults = (Polygon, features) => {
  return {
    id: RESULT_TYPES.OWNER_NAME,
    title: 'Owner Name',
    showResults: false,
    results: features.map(f => ({
      label: f.attributes.OwnerName,
      attributes: f.attributes,
      geometry: new Polygon(f.geometry)
    }))
  }
}

export const ownerSearch = async (Polygon, searchTerm, callback) => {
  const words = searchTerm.match(/\b(\w+)\b/g)
  if (words !== null) {
    const whereClause = encodeURIComponent(
        words.map(word => `LOWER(OwnerName) LIKE '%${word.toLowerCase()}%'`)
          .join(" AND ")
      )
    const response = await fetch(`${PARCEL_SERVICE_URL}/query?where=${whereClause}&outFields=*&returnGeometry=true&outSR=4326&f=pjson`)
    const results = await response.json()
    const formattedResults = processResults(Polygon, results.features)
    if (formattedResults && formattedResults.results.length) callback(formattedResults)
  }
}